import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlarmClockIcon } from 'lucide-react';
export function UrgencySection() {
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section className="w-full py-24 px-4 bg-transparent relative overflow-hidden" data-id="element-288">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[300px] bg-gradOrange/10 blur-[100px] rounded-full pointer-events-none" data-id="element-289" />

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-290">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center w-full" data-id="element-291">
          <AlarmClockIcon className="w-16 h-16 text-gradOrange mb-6 drop-shadow-[0_0_10px_rgba(255,107,0,0.5)]" data-id="element-292" />

          <h2 className="text-3xl md:text-5xl font-black text-white mb-10 leading-tight" data-id="element-293">
            ⏰ El precio de lanzamiento termina en:
          </h2>

          <div className="flex items-center justify-center gap-4 md:gap-8 mb-8" data-id="element-294">
            <div className="flex flex-col items-center" data-id="element-295">
              <div className="bg-cardBg border border-white/10 rounded-2xl w-20 h-24 md:w-32 md:h-36 flex items-center justify-center mb-2" data-id="element-296">
                <span className="text-4xl md:text-7xl font-black text-white tabular-nums tracking-tighter" data-id="element-297">
                  {hours.toString().padStart(2, '0')}
                </span>
              </div>
              <span className="text-textMuted font-bold text-sm md:text-base tracking-widest" data-id="element-298">
                HORAS
              </span>
            </div>
            <span className="text-4xl md:text-6xl font-bold text-white/20 -mt-8" data-id="element-299">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-300">
              <div className="bg-cardBg border border-white/10 rounded-2xl w-20 h-24 md:w-32 md:h-36 flex items-center justify-center mb-2" data-id="element-301">
                <span className="text-4xl md:text-7xl font-black text-white tabular-nums tracking-tighter" data-id="element-302">
                  {minutes.toString().padStart(2, '0')}
                </span>
              </div>
              <span className="text-textMuted font-bold text-sm md:text-base tracking-widest" data-id="element-303">
                MINUTOS
              </span>
            </div>
            <span className="text-4xl md:text-6xl font-bold text-white/20 -mt-8" data-id="element-304">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-305">
              <div className="bg-cardBg border border-white/10 rounded-2xl w-20 h-24 md:w-32 md:h-36 flex items-center justify-center mb-2" data-id="element-306">
                <span className="text-4xl md:text-7xl font-black text-white tabular-nums tracking-tighter" data-id="element-307">
                  {seconds.toString().padStart(2, '0')}
                </span>
              </div>
              <span className="text-textMuted font-bold text-sm md:text-base tracking-widest" data-id="element-308">
                SEGUNDOS
              </span>
            </div>
          </div>

          <p className="text-xl md:text-2xl text-textMuted font-medium mb-12" data-id="element-309">
            Después sube $15.000 ARS y no vuelve a bajar.
          </p>

          <div className="w-full max-w-2xl bg-cardBg rounded-2xl p-6 md:p-8 mb-12 border border-white/5" data-id="element-310">
            <div className="flex justify-between items-end mb-3" data-id="element-311">
              <span className="text-gradPurple font-bold text-sm md:text-base" data-id="element-312">
                ● Cupones al precio de lanzamiento
              </span>
              <span className="text-white font-bold text-sm md:text-base" data-id="element-313">
                Quedan pocos
              </span>
            </div>
            <div className="w-full h-4 bg-spaceBg rounded-full overflow-hidden mb-2 border border-white/5" data-id="element-314">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="h-full bg-gradient-to-r from-gradPurple to-gradPink rounded-full shadow-[0_0_10px_rgba(255,0,85,0.5)]" data-id="element-315" />
            </div>
            <div className="text-right" data-id="element-316">
              <span className="text-textMuted text-sm font-medium" data-id="element-317">
                68% de los cupos tomados
              </span>
            </div>
          </div>

          <motion.a href="https://checkout.infinita-mente.online/checkouts/cn/hWN9hJcYAJ6aX5aJ3wBC1CQj/es-ar?_r=AQAB8bH0zu89K7bsPll58nLRDWhvvq0TO43BcpK3J-clHp8&preview_theme_id=138558668898" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} className="bg-gradient-to-r from-[#10B981] to-[#047857] hover:from-[#059669] hover:to-[#065f46] text-white font-black md:text-2xl px-8 py-3 rounded-full shadow-[0_0_15px_rgba(16,185,129,0.3)] transition-all duration-300 mb-8 w-full md:w-auto inline-block text-center no-underline whitespace-nowrap text-[18px]" data-id="element-318">
            ASEGURAR MI PRECIO AHORA
          </motion.a>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 text-xs md:text-sm font-medium text-textMuted" data-id="element-319">
            <span className="flex items-center gap-2" data-id="element-320">
              <span className="text-white/50" data-id="element-321">🔒</span> Pago 100% seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-322">
              <span className="text-white/50" data-id="element-323">⚡</span> Acceso inmediato
            </span>
            <span className="flex items-center gap-2" data-id="element-324">
              <span className="text-white/50" data-id="element-325">🛡️</span> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-326">
              <span className="text-white/50" data-id="element-327">💳</span> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}